import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PathologyAnatomyService {
  refreshDetails = new BehaviorSubject<any>(false);
  refreshProfileBraches = new BehaviorSubject<boolean>(false);
  activeTab = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) { }

  createPathologyAnatomy(data) {
    return this.http.post(
      `${environment.apiUrl}/PathologyAnatomy/CreatePathologyAnatomy`,
      data
    );
  }
  updatePathologyAnatomy(data) {
    return this.http.put(
      `${environment.apiUrl}/PathologyAnatomy/UpdatePathologyAnatomy`,
      data
    );
  }
  cloneAnatomyPathology(data) {
    return this.http.post(
      `${environment.apiUrl}/PathologyAnatomy/CloneAnatomyPathology`,
      data
    );
  }

  getListPathologyAnatomyExams(params) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/ListPathologyAnatomyExams`,
      { params }
    );
  }

  getListTraineeAnotomyExams(params) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/ListTraineeAnotomyExams`, { params });
  }

  getPathologyExamDataByAnatomyId(params) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/GetPathologyExamDataByAnatomyId`, { params });
  }

  deleteRecord(id: number) {
    return this.http.delete(
      `${environment.apiUrl}/PathologyAnatomy/DeletePathologyAnatomyExam?id=${id}`
    );
  }

  getAnatomyPathologyDetails(id) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/GetAnatomyPathologyDetails?AnatomyPathologyId=${id}`
    );
  }
  AddPathologyAnatomyModule(model) {
    return this.http.post(
      `${environment.apiUrl}/PathologyAnatomy/AddPathologyAnatomyModule`,
      model
    );
  }
  UpdatePathologyAnatomyModule(model) {
    return this.http.put(
      `${environment.apiUrl}/PathologyAnatomy/UpdatePathologyAnatomyModule`,
      model
    );
  }

  getrPathologyAnatomyModuleById(id) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/GetrPathologyAnatomyModuleById?ModuleId=${id}`
    );
  }
  getModuleLessonExamData(id, isPreview) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/GetModuleLessonExamData?moduleLessonId=${id}&IsPreview=${isPreview}`
    );
  }
  createPathologyAnatomyLesson(model) {
    if (model.moduleLesson.id) {
      return this.http.put(
        `${environment.apiUrl}/PathologyAnatomy/UpdatePathologyAnatomyLessonAsync`,
        model
      );
    } else {
      return this.http.post(
        `${environment.apiUrl}/PathologyAnatomy/CreatePathologyAnatomyLesson`,
        model
      );
    }
  }
  deletePathologyAnatomyModule(id: number) {
    return this.http.delete(
      `${environment.apiUrl}/PathologyAnatomy/DeletePathologyAnatomyModule?ModuleId=${id}`
    );
  }
  deletePathologyAnatomyModuleLesson(id: number) {
    return this.http.delete(
      `${environment.apiUrl}/PathologyAnatomy/DeletePathologyAnatomyModuleLesson?ModuleLessonId=${id}`
    );
  }
  publishPathologyAnatomyExam(id: number) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/PublishPathologyAnatomyExam?id=${id}`
    );
  }
  unPublishPathologyAnatomyExam(id: number) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/UnPublishPathologyAnatomyExam?id=${id}`
    );
  }

  getListTraineeUsersForAnatomy(params) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/ListTraineeUsersForAnatomy`,
      { params }
    );
  }
  enrollmentTraineesInAnatomyExam(model) {
    return this.http.post(
      `${environment.apiUrl}/PathologyAnatomy/EnrollmentTraineesInAnatomyExam`,
      model
    );
  }

  getAnatomyAssessmentQuiz(params) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/GetAnatomyAssessmentQuiz`, { params });
  }

  submitAnatomyExamAnswers(model) {
    return this.http.post(`${environment.apiUrl}/PathologyAnatomy/SubmitAnatomyExamAnswers`, model);
  }

  getEssayQuestionPerModule(params: any) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/GetEssayQuestionPerModule`,
      { params }
    );
  }

  setTraineeScorePerQuestionByTrainer(data: any) {
    return this.http.post(
      `${environment.apiUrl}/PathologyAnatomy/SetTraineeScorePerQuestionByTrainer`,
      data
    );
  }

  getPathologyAnatomyExamGraph(id: number) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/GetPathologyAnatomyExamGraph?pathologyAnatomyEntityId=${id}`);
  }

  getAnatomyExamGraphForTrainee(id: number) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/GetAnatomyExamGraphForTrainee?AnotomyModuleId=${id}`);
  }

  assessmentExitLog(id: number) {
    return this.http.post(`${environment.apiUrl}/PathologyAnatomy/AssessmentExitLog?pathologyAnotomyModelId=${id}`, null);
  }
  checkMeetingExit(params: any) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/CheckMeetingExit`, {
      params,
    });
  }
  fireSignalRLiveSesionIsLive(params: any) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/FireSignalRLiveSesionIsLive`,
      { params }
    );
  }

  setTraineeLAttendeeMeeting(params: any) {
    return this.http.get(
      `${environment.apiUrl}/PathologyAnatomy/SetTraineeLAttendeeMeeting`,
      { params }
    );
  }

  setSlideScoreForTrainee(data: any) {
    return this.http.post(`${environment.apiUrl}/PathologyAnatomy/SetSlideScoreForTrainee`, data);
  }

  getSlideScoreReportForTrainee(id: number) {
    return this.http.get(`${environment.apiUrl}/PathologyAnatomy/GetSlideScoreReportForTrainee?moduleId=${id}`);
  }
}
